import Component from 'flarum/common/Component';
import textContrastClass from 'flarum/common/helpers/textContrastClass';
import tagIcon from '../../common/helpers/tagIcon';
import classList from 'flarum/common/utils/classList';
export default class TagHero extends Component {
  view() {
    const tag = this.attrs.model;
    const color = tag.color();
    return m("header", {
      className: classList('Hero', 'TagHero', {
        'TagHero--colored': color,
        [textContrastClass(color)]: color
      }),
      style: color ? {
        '--hero-bg': color
      } : undefined
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, tag.icon() && tagIcon(tag, {}, {
      useColor: false
    }), " ", tag.name()), m("div", {
      className: "Hero-subtitle"
    }, tag.description()))));
  }
}
flarum.reg.add('flarum-tags', 'forum/components/TagHero', TagHero);